export default "__VITE_ASSET__DoxruXPd__"